// Importar el parser para uso interno
import BBCodeParser from './BBCodeParser'

// Exportar el parser principal
export { default as BBCodeParser } from './BBCodeParser'

// Exportar tags personalizados
export { highlightTag, alertTag, tableTag, accordionTag, badgeTag, progressTag, tooltipTag, exampleUsage } from './CustomTags'

// Exportar el componente editor
export { default as BBCodeEditor } from '../../components/BBCodeEditor/BBCodeEditor'

// Función helper para crear un parser con tags personalizados
export const createBBCodeParser = (customTags = []) => {
  const parser = new BBCodeParser()

  customTags.forEach((tag) => {
    parser.registerTag(tag.name, tag.config)
  })

  return parser
}

// Función helper para parsear BBCode directamente
export const parseBBCode = (bbcode, customTags = []) => {
  const parser = createBBCodeParser(customTags)
  return parser.parse(bbcode)
}
